import { HStack, VStack, Text, Box, Flex } from '@chakra-ui/react';
import { Detection } from '@investigator/shared/generated/graphql';
import { SeverityScore } from '@investigator/shared/components/SeverityScore';
import { RouterLink } from '@gamma/ui/navigation';
import { ROUTES } from '@investigator/shared/constants';
import { useDateRangeQueryString } from '@investigator/shared/hooks';
const { systemSettingsAlertCatalog } = ROUTES;

interface DetectionSummaryInformationCardProps {
  title: string;
  date: string;
  detection: Detection;
}

export const DetectionSummaryInformationCard = ({
  title,
  date,
  detection,
}: DetectionSummaryInformationCardProps): JSX.Element => {
  const { start, end } = useDateRangeQueryString();

  return (
    <VStack
      flex="1"
      maxWidth="400px"
      borderRadius="md"
      spacing={0}
      overflow="hidden"
    >
      <HStack
        justifyContent={'space-between'}
        bg="layer.2"
        py={3}
        px={3}
        width="100%"
        borderBottom={'1px solid'}
        borderColor="gray.600"
      >
        <Text>{title}</Text>
        <Text>{date}</Text>
      </HStack>
      <Flex
        py={1}
        px={1}
        bgColor={'layer.2'}
        width="100%"
        alignItems={'center'}
        justifyContent={'middle'}
      >
        <Box zIndex="1">
          <SeverityScore score={detection.rank.severity} />
        </Box>
        <RouterLink
          color="text.link"
          wordBreak={'break-word'}
          fontSize={'l'}
          data-testid="pivot-detection-alert-catalog-link"
          to={`${systemSettingsAlertCatalog(
            `/${detection.alert_info?.content_id}?start=${start}&end=${end}`,
          )}`}
        >
          {detection.alert_info?.alert_name || '—'}
        </RouterLink>
      </Flex>
    </VStack>
  );
};
